import { PostAsync } from "common/httpRequests";
import { BACKEND } from "constants/settings";
import { emailState } from "features/pageSlice";
import { useNavigate } from "react-router-dom";
import { resetOnboardingData } from "redux/slices/onBoardingSlice";
import { logoutSupplierAction } from "redux/slices/supplier";
import { dispatch, persistor } from "redux/store";

export function useLogout() {
  const navigate = useNavigate();

  function logout() {
    const supplierId = localStorage.getItem("supplierId");
    PostAsync(
      `${BACKEND}/api/vendorservice/Suppliers/logout/${supplierId}`,
      {},
    ).finally(() => {
      localStorage.removeItem("supplierId");
      localStorage.removeItem("code");
      localStorage.removeItem("token");
      dispatch(logoutSupplierAction());
      dispatch(resetOnboardingData());
      dispatch(emailState());
      persistor.purge();
      navigate(`/${window.location.pathname.split("/")[1]}`);
    });
  }

  return { logout };
}
